import { REQUEST, FAILURE, SUCCESS } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

const initialState = {
  logs: { count: 0, results: [] },
  logsAreLoaded: false,
  filters: { operators: [], customers: [], tags: [], actions: [] },
  filtersAreLoaded: false,
  exportIsLoading: false,
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_USER_TAG_LOGS[REQUEST]:
      return { ...state, logsAreLoaded: false };
    case ActionTypes.GET_USER_TAG_LOGS[SUCCESS]:
      return { ...state, logs: action.data, logsAreLoaded: true };
    case ActionTypes.GET_USER_TAG_LOGS[FAILURE]:
      return { ...state, error: action.error, logsAreLoaded: true };
    case ActionTypes.GET_USER_TAG_LOG_FILTERS[REQUEST]:
      return { ...state, filtersAreLoaded: false };
    case ActionTypes.GET_USER_TAG_LOG_FILTERS[SUCCESS]:
      return { ...state, filters: action.data, filtersAreLoaded: true };
    case ActionTypes.GET_USER_TAG_LOG_FILTERS[FAILURE]:
      return { ...state, error: action.error, filtersAreLoaded: true };
    case ActionTypes.EXPORT_USER_TAG_LOGS[REQUEST]:
      return { ...state, exportIsLoading: true };
    case ActionTypes.EXPORT_USER_TAG_LOGS[SUCCESS]:
      return { ...state, exportIsLoading: false };
    case ActionTypes.EXPORT_USER_TAG_LOGS[FAILURE]:
      return { ...state, exportIsLoading: false, error: action.error };
    default:
      return state;
  }
};

export default reducer;
